import { ActionContext, ActionTree } from "vuex";
import { ICreditLimitManagementState } from "@/core/interfaces/state/creditLimitManagementState.interface";
import CreditLimitManagementService from "@/modules/CreditLimitManagement/services/creditLimitManagement.service";
import { IPaginatedCreditLimitRequests } from "@/core/interfaces/state/creditLimitRequest.interface";
import { FetchCreditLimitRequestsParamsRequest } from "@/modules/CreditLimitManagement/models/fetchCreditLimitRequestsParams.request";
import { CreateCreditLimitRequestsBody } from "@/modules/CreditLimitManagement/models/createCreditLimitRequestsBody.request";
import { ICreditLimitRequestDetail } from "@/core/interfaces/state/creditLimitRequestDetail.interface";
import { ProcessCreditLimitRequestBody } from "@/modules/CreditLimitManagement/models/processCreditLimitRequestBody.request";
import { StoreState } from "@/store/type";

const actions: ActionTree<ICreditLimitManagementState, StoreState> = {
  async createCreditLimitRequest(
    context: ActionContext<ICreditLimitManagementState, StoreState>,
    {
      body,
      callback,
    }: { body: CreateCreditLimitRequestsBody; callback?: () => void },
  ) {
    context.commit("enableIsCreatingCreditLimitRequests");
    const creditLimitManagementService = new CreditLimitManagementService();
    await creditLimitManagementService.createCreditLimitRequest(body, callback);
    context.commit("disableIsCreatingCreditLimitRequests");
  },

  async processCreditLimitRequest(
    context: ActionContext<ICreditLimitManagementState, StoreState>,
    {
      body,
      callback,
    }: { body: ProcessCreditLimitRequestBody; callback?: () => void },
  ) {
    context.commit("enableIsProcessingCreditLimitRequest");
    const creditLimitManagementService = new CreditLimitManagementService();
    await creditLimitManagementService.processCreditLimitRequest(body);
    context.commit("disableIsProcessingCreditLimitRequest");
    if (callback) {
      callback();
    }
  },
  async fetchCreditLimitRequestDetail(
    context: ActionContext<ICreditLimitManagementState, StoreState>,
    id: string,
  ) {
    context.commit("enableIsFetchingCreditLimitRequestDetail");
    const creditLimitManagementService = new CreditLimitManagementService();
    const response: ICreditLimitRequestDetail | null =
      await creditLimitManagementService.fetchCreditLimitRequestDetail(id);
    context.commit("saveCreditLimitRequestDetail", response);
  },
  async fetchCreditLimitRequests(
    context: ActionContext<ICreditLimitManagementState, StoreState>,
    {
      params,
      callback,
    }: { params: FetchCreditLimitRequestsParamsRequest; callback?: () => void },
  ) {
    context.commit("enableIsFetchCreditLimitRequests");
    const creditLimitManagementService = new CreditLimitManagementService();
    const response: IPaginatedCreditLimitRequests =
      await creditLimitManagementService.fetchCreditLimitRequests(params);
    context.commit("saveCreditLimitRequests", response);
    if (callback) {
      callback();
    }
  },
  async fetchCreditLimitSlabs(
    context: ActionContext<ICreditLimitManagementState, StoreState>,
  ) {
    context.commit("setCreditLimitSlabLoading", true);
    const creditLimitManagementService = new CreditLimitManagementService();
    const response = await creditLimitManagementService.fetchCreditLimitSlabs();
    context.commit("setCreditLimitSlabLoading", false);
    context.commit("saveCreditLimitSlabs", response);
  },
};

export default actions;
